import { SaveProduct } from '../../types';
import { callZigzagFunction } from '../../callZigzagFunction';

// 최근 본 상품에 추가
export const abg = (saveProduct: SaveProduct) => {
  callZigzagFunction('abg')(saveProduct);
};
